var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition",
    { attrs: { name: "fade", appear: "" } },
    [
      _c(_vm.renderCustomAlert, {
        tag: "component",
        attrs: {
          whereIsRendered: _vm.whereIsRendered,
          durationTime: _vm.durationTime,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }